<template>
  <div class="header">
    <div class="headerCon maxWidth clearfix">
      <router-link to="/" class="logo fl">
        <img src="../../static/img/logo.png" alt="" class="pcLogo">
        <img src="../../static/img/wap-logo.png" alt="" class="wapLogo">
      </router-link>
      <div class="nav fl">
        <router-link to="/" class="nav-item">Home</router-link>
        <router-link to="/live" class="nav-item">On Air</router-link>
        <router-link to="/podcast" class="nav-item">Shows & Podcasts</router-link>
      </div>
      <div class="search fl" style="display:none;">
        <form action="" method="get">
          <input type="text" class="searchInp">
          <i class="searchBtn"></i>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      msg: 'header'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .header{
    border-bottom: solid 1px #f3f4f5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: #fff;
    width: 100%;
    .maxWidth{width: 1165px;margin:auto;}
    .headerCon{padding: 56px 0px;}
    .logo{width: 297px;height: 75px;}
    .logo img{width: 100%;}
    .logo .wapLogo{display: none;}
    .nav{margin-left: 80px;margin-top: 22px;}
    .nav-item{display: inline-block;font-size: 32px;line-height: 40px;font-weight: lighter;color: #0085cb;margin-right: 90px;}
    .search{height: 40px;margin-top: 18px;}
    .search form{position: relative;height: 100%;}
    .search .searchInp{height: 100%;border: none;background-color: #f2fafe;border-radius: 20px;text-indent: 15px;font-size: 16px;color: #000;font-weight: initial;font-family: airal;display: block;width: 200px;}
    .search .searchInp::-webkit-input-placeholder{color: #979797;font-size:16px;}
    .search .searchInp:-moz-placeholder{color:#979797;font-size:16px;}
    .search .searchInp::-moz-placeholder{color:#979797;font-size:16px;}
    .search .searchInp:-ms-input-placeholder{color:#979797;font-size:16px;}
    .search .searchBtn{width: 25px;height: 40px;background: url('../../static/img/icon-search.png') no-repeat center center;background-size: 25px 25px;display: block;top: 0;right: 12px;position: absolute;cursor: pointer;}
  }
  @media screen and (max-width: 900px) {
    .header{
      .maxWidth{width: 100%;}
      .headerCon{padding:.3rem .3rem .2rem .3rem;box-sizing: border-box;position: relative;}
      .logo{width: .51rem;height: auto;float: left;}
      .logo img{display: block;}
      .logo .wapLogo{display: block;}
      .logo .pcLogo{display: none;}
      .nav{margin-left: 0px;margin-top: .32rem;}
      .nav-item{font-size: .26rem;line-height: .34rem;margin-left: .3rem;display: block;float: left;font-weight: 400;margin-right: 0;}
      .nav-item:last-child{margin-right: 0;}
      .search{height: .4rem;margin-top: 0;position: absolute;top: .57rem;right: .44rem;}
      .search .searchInp{width: 2rem;font-size: 14px;}
      .search .searchInp::-webkit-input-placeholder{font-size:14px;}
      .search .searchInp:-moz-placeholder{font-size:14px;}
      .search .searchInp::-moz-placeholder{font-size:14px;}
      .search .searchInp:-ms-input-placeholder{font-size:14px;}
      .search .searchBtn{width: .25rem;height: .4rem;background-size: .25rem .25rem;right: .12rem;}
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue